import styled from 'styled-components';

export const RealStateListWrap = styled.div`
    display: block;
    width: 100%;
    overflow: auto;
`;
